import {createAccessCheckHOC} from '@igp/shared/access-control';

import {useBoAgentAccessCheck} from './hooks';

export const withAccessCheck = createAccessCheckHOC(useBoAgentAccessCheck);
